const FormError = {
  baseStyle: {
    text: {
      color: "feedback.negative.100"
    }
  },
};

export default FormError;
